import { Badge } from "@chakra-ui/react";

const BadgeTabelaPadrao = () => (
  <Badge colorScheme="blue" fontSize="0.7em" borderRadius="full" px={2}>
    Padrão do sistema
  </Badge>
);

export default BadgeTabelaPadrao;
